var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagMauritania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18.4843C13.3359 18.4843 11.1103 16.6119 10.5642 14.1116C10.4803 14.496 10.4348 14.8946 10.4348 15.3042C10.4348 18.3779 12.9264 20.8694 16 20.8694C19.0736 20.8694 21.5652 18.3778 21.5652 15.3042C21.5652 14.8946 21.5197 14.496 21.4358 14.1116C20.8898 16.612 18.6641 18.4843 16 18.4843Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 11.1304L16.5182 12.7247H18.1947L16.8385 13.71L17.3565 15.3043L16.0002 14.3189L14.644 15.3043L15.1621 13.71L13.8059 12.7247H15.4822L16.0002 11.1304Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMauritania);
export default __webpack_public_path__ + "static/media/flag_mauritania.b78e27ea840345a484dc5afb00da3e47.svg";
export { ForwardRef as ReactComponent };